import * as M from '@core/api/models';
import { PageHeaderConfig } from '@shared/components/layout/page-header/page-header.models';
import { TabNavigationConfig } from '@shared/components/layout/tab-navigation/tab-navigation.models';

export const DEVELOPER_TABS_CONFIG: TabNavigationConfig = {
  baseRoute: '/home/developer',
  tabs: [
    {
      id: 'developer-view',
      label: 'Deweloper',
      icon: 'pi-eye',
      route: 'view',
    },
    {
      id: 'developer-companies',
      label: 'Firmy',
      icon: 'pi-building',
      route: 'companies',
    },
    {
      id: 'developer-sales-offices',
      label: 'Biura sprzedaży',
      icon: 'pi-map-marker',
      route: 'sales-offices',
    },
  ],
  stickyOffset: 0,
};

export function buildDeveloperPageHeaderConfig(
  developer: M.DeveloperDto | null | undefined
): PageHeaderConfig {
  return {
    title: developer?.name?.trim() || 'Deweloper',
    logoUrl: developer?.logoUrl ?? undefined,
    icon: 'pi-briefcase',
    iconBg: 'var(--p-primary-100)',
    backRoute: '/home',
    backTooltip: 'Powrót do strony głównej',
  };
}

export function buildCompanyEditHeaderConfig(
  developer: M.DeveloperDto | null | undefined,
  options?: {
    backRoute?: string;
    backTooltip?: string;
  }
): PageHeaderConfig {
  return {
    title: 'Edycja firmy',
    logoUrl: developer?.logoUrl ?? undefined,
    icon: 'pi-building',
    iconBg: 'var(--p-primary-100)',
    backRoute: options?.backRoute ?? '/home/developer/companies',
    backTooltip: options?.backTooltip ?? 'Powrót do listy firm',
  };
}
